import { DownloadOption } from '../types'

export type FileType = 'CSV' | 'XLSX' | 'JSON'

export interface State {
  selected: DownloadOption
  fileType: FileType
  email: string
}

export enum ActionType {
  setEmail = 'setEmail',
  setFileType = 'setFileType',
  setSelected = 'setSelected',
  resetState = 'resetState',
}

export type Action =
  | {
      type: ActionType.setSelected
      payload: {
        selected: DownloadOption
      }
    }
  | {
      type: ActionType.setFileType
      payload: {
        fileType: FileType
      }
    }
  | {
      type: ActionType.setEmail
      payload: {
        email: string
      }
    }
  | {
      type: ActionType.resetState
      payload: {
        selected: DownloadOption
        fileType: FileType
        email: string
      }
    }
